// faviconManager.js - Gestión dinámica del favicon y título de la pestaña

class FaviconManager {
  constructor() {
    this.originalTitle = 'MediExamPro - Tu acceso al residentado';
    this.originalFavicon = '/logo-mediexampro.jpeg';
    this.notificationFavicon = '/logo-mediexampro.jpeg';
    this.isBlinking = false;
    this.blinkInterval = null;
  }

  // Inicializar favicon y título
  init() {
    this.setFavicon(this.originalFavicon);
    this.setTitle(this.originalTitle);
    
    // Detectar cuando el usuario cambia de pestaña
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.onTabHidden();
      } else {
        this.onTabVisible();
      }
    });
  }

  // Establecer favicon
  setFavicon(url) {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;
    document.getElementsByTagName('head')[0].appendChild(link);
  }

  // Establecer título
  setTitle(title) {
    document.title = title;
  }

  // Cuando la pestaña se oculta
  onTabHidden() {
    this.setTitle('😴 Vuelve pronto - MediExamPro');
  }

  // Cuando la pestaña se hace visible
  onTabVisible() {
    this.setTitle(this.originalTitle);
    this.stopBlinking();
  }

  // Notificación con parpadeo del favicon
  notify(message) {
    if (document.hidden) {
      this.startBlinking();
      this.setTitle(`🔔 ${message}`);
    }
  }

  // Iniciar parpadeo del favicon
  startBlinking() {
    if (this.isBlinking) return;
    
    this.isBlinking = true;
    let showOriginal = true;
    
    this.blinkInterval = setInterval(() => {
      if (showOriginal) {
        this.setFavicon(this.originalFavicon);
      } else {
        this.setFavicon('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%23FFD700"/><text x="50" y="65" font-size="50" text-anchor="middle" fill="%231E40AF">!</text></svg>');
      }
      showOriginal = !showOriginal;
    }, 500);
  }

  // Detener parpadeo
  stopBlinking() {
    if (!this.isBlinking) return;
    
    this.isBlinking = false;
    clearInterval(this.blinkInterval);
    this.setFavicon(this.originalFavicon);
  }

  // Actualizar progreso en el título
  updateProgress(current, total) {
    const percentage = Math.round((current / total) * 100);
    this.setTitle(`(${percentage}%) MediExamPro - Examen en progreso`);
  }

  // Mostrar tiempo restante en el título
  updateTimeRemaining(minutes, seconds) {
    const timeStr = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    this.setTitle(`⏱️ ${timeStr} - MediExamPro`);
  }

  // Cambiar favicon según el estado
  setStatus(status) {
    const statusIcons = {
      success: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%2310B981"/><text x="50" y="65" font-size="50" text-anchor="middle" fill="white">✓</text></svg>',
      error: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%23EF4444"/><text x="50" y="65" font-size="50" text-anchor="middle" fill="white">✗</text></svg>',
      warning: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%23F59E0B"/><text x="50" y="65" font-size="50" text-anchor="middle" fill="white">!</text></svg>',
      loading: 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%233B82F6"/><text x="50" y="65" font-size="50" text-anchor="middle" fill="white">⟳</text></svg>'
    };

    if (statusIcons[status]) {
      this.setFavicon(statusIcons[status]);
      
      // Volver al original después de 3 segundos
      setTimeout(() => {
        this.setFavicon(this.originalFavicon);
      }, 3000);
    }
  }

  // Animación de favicon con números
  animateNumber(number) {
    const svg = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="%231E40AF"/><text x="50" y="65" font-size="40" text-anchor="middle" fill="%23FFD700">${number}</text></svg>`;
    this.setFavicon(svg);
  }

  // Easter egg: favicon arcoíris
  rainbowMode() {
    const colors = ['%23FF0000', '%23FFA500', '%23FFFF00', '%2300FF00', '%230000FF', '%234B0082', '%239400D3'];
    let colorIndex = 0;
    
    const rainbowInterval = setInterval(() => {
      const svg = `data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><circle cx="50" cy="50" r="40" fill="${colors[colorIndex]}"/><text x="50" y="65" font-size="30" text-anchor="middle" fill="white">MEP</text></svg>`;
      this.setFavicon(svg);
      colorIndex = (colorIndex + 1) % colors.length;
    }, 200);
    
    // Detener después de 5 segundos
    setTimeout(() => {
      clearInterval(rainbowInterval);
      this.setFavicon(this.originalFavicon);
    }, 5000);
  }
}

// Crear instancia singleton
const faviconManager = new FaviconManager();

export default faviconManager;